import React, { useState, useEffect, useRef } from 'react';
import Styles from './DropdownCheckbox.css';

const DropdownCheckbox = ({ categorias, selected, setSelected }) => {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleItem = (item) => {
    setSelected((prev) => (prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]));
  };

  const isSelected = (item) => selected.includes(item);

  // Fecha dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="contente-dropdown" ref={dropdownRef}>
      {selected.length > 0 && <label className="dropdown-label">Categoria</label>}
      <div className="dropdown" onClick={() => setOpen((prev) => !prev)}>
        <span className="dropdown-title">
          {selected.length > 0 ? selected.join(', ') : 'Escolher categoria'}
        </span>
        <img
          src="assets/bens-e-servicos/ic_16_arrow_down.png"
          alt="Seta"
          className="dropdown-arrow"
        />
      </div>

      {open && (
        <div className="dropdown-results-content">
          {categorias.map((item, index) => (
            <div
              key={index}
              className="dropdown-results"
              onClick={(e) => {
                e.stopPropagation();
                toggleItem(item);
              }}
            >
              <div className={`result ${isSelected(item) ? 'result-selected' : ''}`}>
                {isSelected(item) && (
                  <img src="assets/bens-e-servicos/check.svg" alt="check imagem" />
                )}
              </div>
              <span>{item}</span>
            </div>
          ))}
        </div>
      )}
      <style jsx>{Styles}</style>
    </div>
  );
};

export default DropdownCheckbox;
